
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var $f22fea531ee465de$exports = {};
'use strict';
var $ee3594ab38f6167c$exports = {};
/**
 * This module used to unify mouse wheel behavior between different browsers in 2014
 * Now it's just a wrapper around addEventListener('wheel');
 *
 * Usage:
 *  var addWheelListener = require('wheel').addWheelListener;
 *  var removeWheelListener = require('wheel').removeWheelListener;
 *  addWheelListener(domElement, function (e) {
 *    // mouse wheel event
 *  });
 *  removeWheelListener(domElement, function);
 */ $ee3594ab38f6167c$exports = $ee3594ab38f6167c$var$addWheelListener;
// But also expose "advanced" api with unsubscribe:
$ee3594ab38f6167c$exports.addWheelListener = $ee3594ab38f6167c$var$addWheelListener;
$ee3594ab38f6167c$exports.removeWheelListener = $ee3594ab38f6167c$var$removeWheelListener;
function $ee3594ab38f6167c$var$addWheelListener(element, listener, useCapture) {
    element.addEventListener('wheel', listener, useCapture);
}
function $ee3594ab38f6167c$var$removeWheelListener(element, listener, useCapture) {
    element.removeEventListener('wheel', listener, useCapture);
}


var $abd4e73c78068168$exports = {};
var $368e738781e188a9$exports = {};
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
var $368e738781e188a9$var$NEWTON_ITERATIONS = 4;
var $368e738781e188a9$var$NEWTON_MIN_SLOPE = 0.001;
var $368e738781e188a9$var$SUBDIVISION_PRECISION = 0.0000001;
var $368e738781e188a9$var$SUBDIVISION_MAX_ITERATIONS = 10;
var $368e738781e188a9$var$kSplineTableSize = 11;
var $368e738781e188a9$var$kSampleStepSize = 1.0 / ($368e738781e188a9$var$kSplineTableSize - 1.0);
var $368e738781e188a9$var$float32ArraySupported = typeof Float32Array === 'function';
function $368e738781e188a9$var$A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}
function $368e738781e188a9$var$B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
}
function $368e738781e188a9$var$C(aA1) {
    return 3.0 * aA1;
}
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function $368e738781e188a9$var$calcBezier(aT, aA1, aA2) {
    return (($368e738781e188a9$var$A(aA1, aA2) * aT + $368e738781e188a9$var$B(aA1, aA2)) * aT + $368e738781e188a9$var$C(aA1)) * aT;
}
// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function $368e738781e188a9$var$getSlope(aT, aA1, aA2) {
    return 3.0 * $368e738781e188a9$var$A(aA1, aA2) * aT * aT + 2.0 * $368e738781e188a9$var$B(aA1, aA2) * aT + $368e738781e188a9$var$C(aA1);
}
function $368e738781e188a9$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $368e738781e188a9$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $368e738781e188a9$var$SUBDIVISION_PRECISION && ++i < $368e738781e188a9$var$SUBDIVISION_MAX_ITERATIONS);
    return currentT;
}
function $368e738781e188a9$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $368e738781e188a9$var$NEWTON_ITERATIONS; ++i){
        var currentSlope = $368e738781e188a9$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $368e738781e188a9$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
function $368e738781e188a9$var$LinearEasing(x) {
    return x;
}
$368e738781e188a9$exports = function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) throw new Error('bezier x values must be in [0, 1] range');
    if (mX1 === mY1 && mX2 === mY2) return $368e738781e188a9$var$LinearEasing;
    // Precompute samples table
    var sampleValues = $368e738781e188a9$var$float32ArraySupported ? new Float32Array($368e738781e188a9$var$kSplineTableSize) : new Array($368e738781e188a9$var$kSplineTableSize);
    for(var i = 0; i < $368e738781e188a9$var$kSplineTableSize; ++i)sampleValues[i] = $368e738781e188a9$var$calcBezier(i * $368e738781e188a9$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $368e738781e188a9$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $368e738781e188a9$var$kSampleStepSize;
        --currentSample;
        // Interpolate to provide an initial guess for t
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $368e738781e188a9$var$kSampleStepSize;
        var initialSlope = $368e738781e188a9$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $368e738781e188a9$var$NEWTON_MIN_SLOPE) return $368e738781e188a9$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $368e738781e188a9$var$binarySubdivide(aX, intervalStart, intervalStart + $368e738781e188a9$var$kSampleStepSize, mX1, mX2);
    }
    return function BezierEasing(x) {
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (x === 0) return 0;
        if (x === 1) return 1;
        return $368e738781e188a9$var$calcBezier(getTForX(x), mY1, mY2);
    };
};


// Predefined set of animations. Similar to CSS easing functions
var $abd4e73c78068168$var$animations = {
    ease: $368e738781e188a9$exports(0.25, 0.1, 0.25, 1),
    easeIn: $368e738781e188a9$exports(0.42, 0, 1, 1),
    easeOut: $368e738781e188a9$exports(0, 0, 0.58, 1),
    easeInOut: $368e738781e188a9$exports(0.42, 0, 0.58, 1),
    linear: $368e738781e188a9$exports(0, 0, 1, 1)
};
$abd4e73c78068168$exports = $abd4e73c78068168$var$animate;
$abd4e73c78068168$exports.makeAggregateRaf = $abd4e73c78068168$var$makeAggregateRaf;
$abd4e73c78068168$exports.sharedScheduler = $abd4e73c78068168$var$makeAggregateRaf();
function $abd4e73c78068168$var$animate(source, target, options) {
    var start = Object.create(null);
    var diff = Object.create(null);
    options = options || {};
    // We let clients specify their own easing function
    var easing = typeof options.easing === 'function' ? options.easing : $abd4e73c78068168$var$animations[options.easing];
    // if nothing is specified, default to ease (similar to CSS animations)
    if (!easing) {
        if (options.easing) console.warn('Unknown easing function in amator: ' + options.easing);
        easing = $abd4e73c78068168$var$animations.ease;
    }
    var step = typeof options.step === 'function' ? options.step : $abd4e73c78068168$var$noop;
    var done = typeof options.done === 'function' ? options.done : $abd4e73c78068168$var$noop;
    var scheduler = $abd4e73c78068168$var$getScheduler(options.scheduler);
    var keys = Object.keys(target);
    keys.forEach(function(key) {
        start[key] = source[key];
        diff[key] = target[key] - source[key];
    });
    var durationInMs = typeof options.duration === 'number' ? options.duration : 400;
    var durationInFrames = Math.max(1, durationInMs * 0.06) // 0.06 because 60 frames pers 1,000 ms
    ;
    var previousAnimationId;
    var frame = 0;
    previousAnimationId = scheduler.next(loop);
    return {
        cancel: cancel
    };
    function cancel() {
        scheduler.cancel(previousAnimationId);
        previousAnimationId = 0;
    }
    function loop() {
        var t = easing(frame / durationInFrames);
        frame += 1;
        setValues(t);
        if (frame <= durationInFrames) {
            previousAnimationId = scheduler.next(loop);
            step(source);
        } else {
            previousAnimationId = 0;
            setTimeout(function() {
                done(source);
            }, 0);
        }
    }
    function setValues(t) {
        keys.forEach(function(key) {
            source[key] = diff[key] * t + start[key];
        });
    }
}
function $abd4e73c78068168$var$noop() {}
function $abd4e73c78068168$var$getScheduler(scheduler) {
    if (!scheduler) {
        var canRaf = typeof window !== 'undefined' && window.requestAnimationFrame;
        return canRaf ? $abd4e73c78068168$var$rafScheduler() : $abd4e73c78068168$var$timeoutScheduler();
    }
    if (typeof scheduler.next !== 'function') throw new Error('Scheduler is supposed to have next(cb) function');
    if (typeof scheduler.cancel !== 'function') throw new Error('Scheduler is supposed to have cancel(handle) function');
    return scheduler;
}
function $abd4e73c78068168$var$rafScheduler() {
    return {
        next: window.requestAnimationFrame.bind(window),
        cancel: window.cancelAnimationFrame.bind(window)
    };
}
function $abd4e73c78068168$var$timeoutScheduler() {
    return {
        next: function(cb) {
            return setTimeout(cb, 1000 / 60);
        },
        cancel: function(id) {
            return clearTimeout(id);
        }
    };
}
function $abd4e73c78068168$var$makeAggregateRaf() {
    var frontBuffer = new Set();
    var backBuffer = new Set();
    var frameToken = 0;
    return {
        next: next,
        cancel: next,
        clearAll: clearAll
    };
    function clearAll() {
        frontBuffer.clear();
        backBuffer.clear();
        cancelAnimationFrame(frameToken);
        frameToken = 0;
    }
    function next(callback) {
        backBuffer.add(callback);
        renderNextFrame();
    }
    function renderNextFrame() {
        if (!frameToken) frameToken = requestAnimationFrame(renderFrame);
    }
    function renderFrame() {
        frameToken = 0;
        var t = backBuffer;
        backBuffer = frontBuffer;
        frontBuffer = t;
        frontBuffer.forEach(function(callback) {
            callback();
        });
        frontBuffer.clear();
    }
    function cancel(callback) {
        backBuffer.delete(callback);
    }
}


var $3f984ebf2aba86a9$exports = {};
$3f984ebf2aba86a9$exports = function eventify(subject) {
    $3f984ebf2aba86a9$var$validateSubject(subject);
    var eventsStorage = $3f984ebf2aba86a9$var$createEventsStorage(subject);
    subject.on = eventsStorage.on;
    subject.off = eventsStorage.off;
    subject.fire = eventsStorage.fire;
    return subject;
};
function $3f984ebf2aba86a9$var$createEventsStorage(subject) {
    // Store all event listeners to this hash. Key is event name, value is array
    // of callback records.
    //
    // A callback record consists of callback function and its optional context:
    // { 'eventName' => [{callback: function, ctx: object}] }
    var registeredEvents = Object.create(null);
    return {
        on: function(eventName, callback, ctx) {
            if (typeof callback !== 'function') throw new Error('callback is expected to be a function');
            var handlers = registeredEvents[eventName];
            if (!handlers) handlers = registeredEvents[eventName] = [];
            handlers.push({
                callback: callback,
                ctx: ctx
            });
            return subject;
        },
        off: function(eventName, callback) {
            var wantToRemoveAll = typeof eventName === 'undefined';
            if (wantToRemoveAll) {
                // Killing old events storage should be enough in this case:
                registeredEvents = Object.create(null);
                return subject;
            }
            if (registeredEvents[eventName]) {
                var deleteAllCallbacksForEvent = typeof callback !== 'function';
                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                else {
                    var callbacks = registeredEvents[eventName];
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                }
            }
            return subject;
        },
        fire: function(eventName) {
            var callbacks = registeredEvents[eventName];
            if (!callbacks) return subject;
            var fireArguments;
            if (arguments.length > 1) fireArguments = Array.prototype.splice.call(arguments, 1);
            for(var i = 0; i < callbacks.length; ++i){
                var callbackInfo = callbacks[i];
                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
            }
            return subject;
        }
    };
}
function $3f984ebf2aba86a9$var$validateSubject(subject) {
    if (!subject) throw new Error('Eventify cannot use falsy object as events subject');
    var reservedWords = [
        'on',
        'fire',
        'off'
    ];
    for(var i = 0; i < reservedWords.length; ++i){
        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
    }
}


var $045989394badc850$exports = {};
/**
 * Allows smooth kinetic scrolling of the surface
 */ $045989394badc850$exports = $045989394badc850$var$kinetic;
function $045989394badc850$var$kinetic(getPoint, scroll, settings) {
    if (typeof settings !== 'object') // setting could come as boolean, we should ignore it, and use an object.
    settings = {};
    var minVelocity = typeof settings.minVelocity === 'number' ? settings.minVelocity : 5;
    var amplitude = typeof settings.amplitude === 'number' ? settings.amplitude : 0.25;
    var cancelAnimationFrame1 = typeof settings.cancelAnimationFrame === 'function' ? settings.cancelAnimationFrame : $045989394badc850$var$getCancelAnimationFrame();
    var requestAnimationFrame1 = typeof settings.requestAnimationFrame === 'function' ? settings.requestAnimationFrame : $045989394badc850$var$getRequestAnimationFrame();
    var lastPoint;
    var timestamp;
    var timeConstant = 342;
    var ticker;
    var vx, targetX, ax;
    var vy, targetY, ay;
    var raf;
    return {
        start: start,
        stop: stop,
        cancel: dispose
    };
    function dispose() {
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
    }
    function start() {
        lastPoint = getPoint();
        ax = ay = vx = vy = 0;
        timestamp = new Date();
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
        // we start polling the point position to accumulate velocity
        // Once we stop(), we will use accumulated velocity to keep scrolling
        // an object.
        ticker = requestAnimationFrame1(track);
    }
    function track() {
        var now = Date.now();
        var elapsed = now - timestamp;
        timestamp = now;
        var currentPoint = getPoint();
        var dx = currentPoint.x - lastPoint.x;
        var dy = currentPoint.y - lastPoint.y;
        lastPoint = currentPoint;
        var dt = 1000 / (1 + elapsed);
        // moving average
        vx = 0.8 * dx * dt + 0.2 * vx;
        vy = 0.8 * dy * dt + 0.2 * vy;
        ticker = requestAnimationFrame1(track);
    }
    function stop() {
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
        var currentPoint = getPoint();
        targetX = currentPoint.x;
        targetY = currentPoint.y;
        timestamp = Date.now();
        if (vx < -minVelocity || vx > minVelocity) {
            ax = amplitude * vx;
            targetX += ax;
        }
        if (vy < -minVelocity || vy > minVelocity) {
            ay = amplitude * vy;
            targetY += ay;
        }
        raf = requestAnimationFrame1(autoScroll);
    }
    function autoScroll() {
        var elapsed = Date.now() - timestamp;
        var moving = false;
        var dx = 0;
        var dy = 0;
        if (ax) {
            dx = -ax * Math.exp(-elapsed / timeConstant);
            if (dx > 0.5 || dx < -0.5) moving = true;
            else dx = ax = 0;
        }
        if (ay) {
            dy = -ay * Math.exp(-elapsed / timeConstant);
            if (dy > 0.5 || dy < -0.5) moving = true;
            else dy = ay = 0;
        }
        if (moving) {
            scroll(targetX + dx, targetY + dy);
            raf = requestAnimationFrame1(autoScroll);
        }
    }
}
function $045989394badc850$var$getCancelAnimationFrame() {
    if (typeof cancelAnimationFrame === 'function') return cancelAnimationFrame;
    return clearTimeout;
}
function $045989394badc850$var$getRequestAnimationFrame() {
    if (typeof requestAnimationFrame === 'function') return requestAnimationFrame;
    return function(handler) {
        return setTimeout(handler, 16);
    };
}


var $f4e2629871e48550$exports = {};
/**
 * Disallows selecting text.
 */ $f4e2629871e48550$exports = $f4e2629871e48550$var$createTextSelectionInterceptor;
function $f4e2629871e48550$var$createTextSelectionInterceptor(useFake) {
    if (useFake) return {
        capture: $f4e2629871e48550$var$noop,
        release: $f4e2629871e48550$var$noop
    };
    var dragObject;
    var prevSelectStart;
    var prevDragStart;
    var wasCaptured = false;
    return {
        capture: capture,
        release: release
    };
    function capture(domObject) {
        wasCaptured = true;
        prevSelectStart = window.document.onselectstart;
        prevDragStart = window.document.ondragstart;
        window.document.onselectstart = $f4e2629871e48550$var$disabled;
        dragObject = domObject;
        dragObject.ondragstart = $f4e2629871e48550$var$disabled;
    }
    function release() {
        if (!wasCaptured) return;
        wasCaptured = false;
        window.document.onselectstart = prevSelectStart;
        if (dragObject) dragObject.ondragstart = prevDragStart;
    }
}
function $f4e2629871e48550$var$disabled(e) {
    e.stopPropagation();
    return false;
}
function $f4e2629871e48550$var$noop() {}


var $f22fea531ee465de$var$domTextSelectionInterceptor = $f4e2629871e48550$exports();
var $f22fea531ee465de$var$fakeTextSelectorInterceptor = $f4e2629871e48550$exports(true);
var $9f1de407a2889729$exports = {};
$9f1de407a2889729$exports = $9f1de407a2889729$var$Transform;
function $9f1de407a2889729$var$Transform() {
    this.x = 0;
    this.y = 0;
    this.scale = 1;
}


var $328194bd245b8736$exports = {};
$328194bd245b8736$exports = $328194bd245b8736$var$makeSvgController;
$328194bd245b8736$exports.canAttach = $328194bd245b8736$var$isSVGElement;
function $328194bd245b8736$var$makeSvgController(svgElement, options) {
    if (!$328194bd245b8736$var$isSVGElement(svgElement)) throw new Error('svg element is required for svg.panzoom to work');
    var owner = svgElement.ownerSVGElement;
    if (!owner) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
    if (!options.disableKeyboardInteraction) owner.setAttribute('tabindex', 0);
    var api = {
        getBBox: getBBox,
        getScreenCTM: getScreenCTM,
        getOwner: getOwner,
        applyTransform: applyTransform,
        initTransform: initTransform
    };
    return api;
    function getOwner() {
        return owner;
    }
    function getBBox() {
        var bbox = svgElement.getBBox();
        return {
            left: bbox.x,
            top: bbox.y,
            width: bbox.width,
            height: bbox.height
        };
    }
    function getScreenCTM() {
        var ctm = owner.getCTM();
        if (!ctm) // This is likely firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=873106
        // The code below is not entirely correct, but still better than nothing
        return owner.getScreenCTM();
        return ctm;
    }
    function initTransform(transform) {
        var screenCTM = svgElement.getCTM();
        // The above line returns null on Firefox
        if (screenCTM === null) screenCTM = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix();
        transform.x = screenCTM.e;
        transform.y = screenCTM.f;
        transform.scale = screenCTM.a;
        owner.removeAttributeNS(null, 'viewBox');
    }
    function applyTransform(transform) {
        svgElement.setAttribute('transform', 'matrix(' + transform.scale + ' 0 0 ' + transform.scale + ' ' + transform.x + ' ' + transform.y + ')');
    }
}
function $328194bd245b8736$var$isSVGElement(element) {
    return element && element.ownerSVGElement && element.getCTM;
}


var $3ad745e165357d59$exports = {};
$3ad745e165357d59$exports = $3ad745e165357d59$var$makeDomController;
$3ad745e165357d59$exports.canAttach = $3ad745e165357d59$var$isDomElement;
function $3ad745e165357d59$var$makeDomController(domElement, options) {
    var elementValid = $3ad745e165357d59$var$isDomElement(domElement);
    if (!elementValid) throw new Error('panzoom requires DOM element to be attached to the DOM tree');
    var owner = domElement.parentElement;
    domElement.scrollTop = 0;
    if (!options.disableKeyboardInteraction) owner.setAttribute('tabindex', 0);
    var api = {
        getBBox: getBBox,
        getOwner: getOwner,
        applyTransform: applyTransform
    };
    return api;
    function getOwner() {
        return owner;
    }
    function getBBox() {
        // TODO: We should probably cache this?
        return {
            left: 0,
            top: 0,
            width: domElement.clientWidth,
            height: domElement.clientHeight
        };
    }
    function applyTransform(transform) {
        // TODO: Should we cache this?
        domElement.style.transformOrigin = '0 0 0';
        domElement.style.transform = 'matrix(' + transform.scale + ', 0, 0, ' + transform.scale + ', ' + transform.x + ', ' + transform.y + ')';
    }
}
function $3ad745e165357d59$var$isDomElement(element) {
    return element && element.parentElement && element.style;
}


var $f22fea531ee465de$var$defaultZoomSpeed = 1;
var $f22fea531ee465de$var$defaultDoubleTapZoomSpeed = 1.75;
var $f22fea531ee465de$var$doubleTapSpeedInMS = 300;
var $f22fea531ee465de$var$clickEventTimeInMS = 200;
$f22fea531ee465de$exports = $f22fea531ee465de$var$createPanZoom;
/**
 * Creates a new instance of panzoom, so that an object can be panned and zoomed
 *
 * @param {DOMElement} domElement where panzoom should be attached.
 * @param {Object} options that configure behavior.
 */ function $f22fea531ee465de$var$createPanZoom(domElement, options) {
    options = options || {};
    var panController = options.controller;
    if (!panController) {
        if ($328194bd245b8736$exports.canAttach(domElement)) panController = $328194bd245b8736$exports(domElement, options);
        else if ($3ad745e165357d59$exports.canAttach(domElement)) panController = $3ad745e165357d59$exports(domElement, options);
    }
    if (!panController) throw new Error('Cannot create panzoom for the current type of dom element');
    var owner = panController.getOwner();
    // just to avoid GC pressure, every time we do intermediate transform
    // we return this object. For internal use only. Never give it back to the consumer of this library
    var storedCTMResult = {
        x: 0,
        y: 0
    };
    var isDirty = false;
    var transform = new $9f1de407a2889729$exports();
    if (panController.initTransform) panController.initTransform(transform);
    var filterKey = typeof options.filterKey === 'function' ? options.filterKey : $f22fea531ee465de$var$noop;
    // TODO: likely need to unite pinchSpeed with zoomSpeed
    var pinchSpeed = typeof options.pinchSpeed === 'number' ? options.pinchSpeed : 1;
    var bounds = options.bounds;
    var maxZoom = typeof options.maxZoom === 'number' ? options.maxZoom : Number.POSITIVE_INFINITY;
    var minZoom = typeof options.minZoom === 'number' ? options.minZoom : 0;
    var boundsPadding = typeof options.boundsPadding === 'number' ? options.boundsPadding : 0.05;
    var zoomDoubleClickSpeed = typeof options.zoomDoubleClickSpeed === 'number' ? options.zoomDoubleClickSpeed : $f22fea531ee465de$var$defaultDoubleTapZoomSpeed;
    var beforeWheel = options.beforeWheel || $f22fea531ee465de$var$noop;
    var beforeMouseDown = options.beforeMouseDown || $f22fea531ee465de$var$noop;
    var speed = typeof options.zoomSpeed === 'number' ? options.zoomSpeed : $f22fea531ee465de$var$defaultZoomSpeed;
    var transformOrigin = $f22fea531ee465de$var$parseTransformOrigin(options.transformOrigin);
    var textSelection = options.enableTextSelection ? $f22fea531ee465de$var$fakeTextSelectorInterceptor : $f22fea531ee465de$var$domTextSelectionInterceptor;
    $f22fea531ee465de$var$validateBounds(bounds);
    if (options.autocenter) autocenter();
    var frameAnimation;
    var lastTouchEndTime = 0;
    var lastTouchStartTime = 0;
    var pendingClickEventTimeout = 0;
    var lastMouseDownedEvent = null;
    var lastMouseDownTime = new Date();
    var lastSingleFingerOffset;
    var touchInProgress = false;
    // We only need to fire panstart when actual move happens
    var panstartFired = false;
    // cache mouse coordinates here
    var mouseX;
    var mouseY;
    // Where the first click has happened, so that we can differentiate
    // between pan and click
    var clickX;
    var clickY;
    var pinchZoomLength;
    var smoothScroll;
    if ('smoothScroll' in options && !options.smoothScroll) // If user explicitly asked us not to use smooth scrolling, we obey
    smoothScroll = $f22fea531ee465de$var$rigidScroll();
    else // otherwise we use forward smoothScroll settings to kinetic API
    // which makes scroll smoothing.
    smoothScroll = $045989394badc850$exports(getPoint, scroll, options.smoothScroll);
    var moveByAnimation;
    var zoomToAnimation;
    var multiTouch;
    var paused = false;
    listenForEvents();
    var api = {
        dispose: dispose,
        moveBy: internalMoveBy,
        moveTo: moveTo,
        smoothMoveTo: smoothMoveTo,
        centerOn: centerOn,
        zoomTo: publicZoomTo,
        zoomAbs: zoomAbs,
        smoothZoom: smoothZoom,
        smoothZoomAbs: smoothZoomAbs,
        showRectangle: showRectangle,
        pause: pause,
        resume: resume,
        isPaused: isPaused,
        getTransform: getTransformModel,
        getMinZoom: getMinZoom,
        setMinZoom: setMinZoom,
        getMaxZoom: getMaxZoom,
        setMaxZoom: setMaxZoom,
        getTransformOrigin: getTransformOrigin,
        setTransformOrigin: setTransformOrigin,
        getZoomSpeed: getZoomSpeed,
        setZoomSpeed: setZoomSpeed
    };
    $3f984ebf2aba86a9$exports(api);
    var initialX = typeof options.initialX === 'number' ? options.initialX : transform.x;
    var initialY = typeof options.initialY === 'number' ? options.initialY : transform.y;
    var initialZoom = typeof options.initialZoom === 'number' ? options.initialZoom : transform.scale;
    if (initialX != transform.x || initialY != transform.y || initialZoom != transform.scale) zoomAbs(initialX, initialY, initialZoom);
    return api;
    function pause() {
        releaseEvents();
        paused = true;
    }
    function resume() {
        if (paused) {
            listenForEvents();
            paused = false;
        }
    }
    function isPaused() {
        return paused;
    }
    function showRectangle(rect) {
        // TODO: this duplicates autocenter. I think autocenter should go.
        var clientRect = owner.getBoundingClientRect();
        var size = transformToScreen(clientRect.width, clientRect.height);
        var rectWidth = rect.right - rect.left;
        var rectHeight = rect.bottom - rect.top;
        if (!Number.isFinite(rectWidth) || !Number.isFinite(rectHeight)) throw new Error('Invalid rectangle');
        var dw = size.x / rectWidth;
        var dh = size.y / rectHeight;
        var scale = Math.min(dw, dh);
        transform.x = -(rect.left + rectWidth / 2) * scale + size.x / 2;
        transform.y = -(rect.top + rectHeight / 2) * scale + size.y / 2;
        transform.scale = scale;
    }
    function transformToScreen(x, y) {
        if (panController.getScreenCTM) {
            var parentCTM = panController.getScreenCTM();
            var parentScaleX = parentCTM.a;
            var parentScaleY = parentCTM.d;
            var parentOffsetX = parentCTM.e;
            var parentOffsetY = parentCTM.f;
            storedCTMResult.x = x * parentScaleX - parentOffsetX;
            storedCTMResult.y = y * parentScaleY - parentOffsetY;
        } else {
            storedCTMResult.x = x;
            storedCTMResult.y = y;
        }
        return storedCTMResult;
    }
    function autocenter() {
        var w; // width of the parent
        var h; // height of the parent
        var left = 0;
        var top = 0;
        var sceneBoundingBox = getBoundingBox();
        if (sceneBoundingBox) {
            // If we have bounding box - use it.
            left = sceneBoundingBox.left;
            top = sceneBoundingBox.top;
            w = sceneBoundingBox.right - sceneBoundingBox.left;
            h = sceneBoundingBox.bottom - sceneBoundingBox.top;
        } else {
            // otherwise just use whatever space we have
            var ownerRect = owner.getBoundingClientRect();
            w = ownerRect.width;
            h = ownerRect.height;
        }
        var bbox = panController.getBBox();
        if (bbox.width === 0 || bbox.height === 0) // we probably do not have any elements in the SVG
        // just bail out;
        return;
        var dh = h / bbox.height;
        var dw = w / bbox.width;
        var scale = Math.min(dw, dh);
        transform.x = -(bbox.left + bbox.width / 2) * scale + w / 2 + left;
        transform.y = -(bbox.top + bbox.height / 2) * scale + h / 2 + top;
        transform.scale = scale;
    }
    function getTransformModel() {
        // TODO: should this be read only?
        return transform;
    }
    function getMinZoom() {
        return minZoom;
    }
    function setMinZoom(newMinZoom) {
        minZoom = newMinZoom;
    }
    function getMaxZoom() {
        return maxZoom;
    }
    function setMaxZoom(newMaxZoom) {
        maxZoom = newMaxZoom;
    }
    function getTransformOrigin() {
        return transformOrigin;
    }
    function setTransformOrigin(newTransformOrigin) {
        transformOrigin = $f22fea531ee465de$var$parseTransformOrigin(newTransformOrigin);
    }
    function getZoomSpeed() {
        return speed;
    }
    function setZoomSpeed(newSpeed) {
        if (!Number.isFinite(newSpeed)) throw new Error('Zoom speed should be a number');
        speed = newSpeed;
    }
    function getPoint() {
        return {
            x: transform.x,
            y: transform.y
        };
    }
    function moveTo(x, y) {
        transform.x = x;
        transform.y = y;
        keepTransformInsideBounds();
        triggerEvent('pan');
        makeDirty();
    }
    function moveBy(dx, dy) {
        moveTo(transform.x + dx, transform.y + dy);
    }
    function keepTransformInsideBounds() {
        var boundingBox = getBoundingBox();
        if (!boundingBox) return;
        var adjusted = false;
        var clientRect = getClientRect();
        var diff = boundingBox.left - clientRect.right;
        if (diff > 0) {
            transform.x += diff;
            adjusted = true;
        }
        // check the other side:
        diff = boundingBox.right - clientRect.left;
        if (diff < 0) {
            transform.x += diff;
            adjusted = true;
        }
        // y axis:
        diff = boundingBox.top - clientRect.bottom;
        if (diff > 0) {
            // we adjust transform, so that it matches exactly our bounding box:
            // transform.y = boundingBox.top - (boundingBox.height + boundingBox.y) * transform.scale =>
            // transform.y = boundingBox.top - (clientRect.bottom - transform.y) =>
            // transform.y = diff + transform.y =>
            transform.y += diff;
            adjusted = true;
        }
        diff = boundingBox.bottom - clientRect.top;
        if (diff < 0) {
            transform.y += diff;
            adjusted = true;
        }
        return adjusted;
    }
    /**
   * Returns bounding box that should be used to restrict scene movement.
   */ function getBoundingBox() {
        if (!bounds) return; // client does not want to restrict movement
        if (typeof bounds === 'boolean') {
            // for boolean type we use parent container bounds
            var ownerRect = owner.getBoundingClientRect();
            var sceneWidth = ownerRect.width;
            var sceneHeight = ownerRect.height;
            return {
                left: sceneWidth * boundsPadding,
                top: sceneHeight * boundsPadding,
                right: sceneWidth * (1 - boundsPadding),
                bottom: sceneHeight * (1 - boundsPadding)
            };
        }
        return bounds;
    }
    function getClientRect() {
        var bbox = panController.getBBox();
        var leftTop = client(bbox.left, bbox.top);
        return {
            left: leftTop.x,
            top: leftTop.y,
            right: bbox.width * transform.scale + leftTop.x,
            bottom: bbox.height * transform.scale + leftTop.y
        };
    }
    function client(x, y) {
        return {
            x: x * transform.scale + transform.x,
            y: y * transform.scale + transform.y
        };
    }
    function makeDirty() {
        isDirty = true;
        frameAnimation = window.requestAnimationFrame(frame);
    }
    function zoomByRatio(clientX, clientY, ratio) {
        if ($f22fea531ee465de$var$isNaN(clientX) || $f22fea531ee465de$var$isNaN(clientY) || $f22fea531ee465de$var$isNaN(ratio)) throw new Error('zoom requires valid numbers');
        var newScale = transform.scale * ratio;
        if (newScale < minZoom) {
            if (transform.scale === minZoom) return;
            ratio = minZoom / transform.scale;
        }
        if (newScale > maxZoom) {
            if (transform.scale === maxZoom) return;
            ratio = maxZoom / transform.scale;
        }
        var size = transformToScreen(clientX, clientY);
        transform.x = size.x - ratio * (size.x - transform.x);
        transform.y = size.y - ratio * (size.y - transform.y);
        // TODO: https://github.com/anvaka/panzoom/issues/112
        if (bounds && boundsPadding === 1 && minZoom === 1) {
            transform.scale *= ratio;
            keepTransformInsideBounds();
        } else {
            var transformAdjusted = keepTransformInsideBounds();
            if (!transformAdjusted) transform.scale *= ratio;
        }
        triggerEvent('zoom');
        makeDirty();
    }
    function zoomAbs(clientX, clientY, zoomLevel) {
        var ratio = zoomLevel / transform.scale;
        zoomByRatio(clientX, clientY, ratio);
    }
    function centerOn(ui) {
        var parent = ui.ownerSVGElement;
        if (!parent) throw new Error('ui element is required to be within the scene');
        // TODO: should i use controller's screen CTM?
        var clientRect = ui.getBoundingClientRect();
        var cx = clientRect.left + clientRect.width / 2;
        var cy = clientRect.top + clientRect.height / 2;
        var container = parent.getBoundingClientRect();
        var dx = container.width / 2 - cx;
        var dy = container.height / 2 - cy;
        internalMoveBy(dx, dy, true);
    }
    function smoothMoveTo(x, y) {
        internalMoveBy(x - transform.x, y - transform.y, true);
    }
    function internalMoveBy(dx, dy, smooth) {
        if (!smooth) return moveBy(dx, dy);
        if (moveByAnimation) moveByAnimation.cancel();
        var from = {
            x: 0,
            y: 0
        };
        var to = {
            x: dx,
            y: dy
        };
        var lastX = 0;
        var lastY = 0;
        moveByAnimation = $abd4e73c78068168$exports(from, to, {
            step: function(v) {
                moveBy(v.x - lastX, v.y - lastY);
                lastX = v.x;
                lastY = v.y;
            }
        });
    }
    function scroll(x, y) {
        cancelZoomAnimation();
        moveTo(x, y);
    }
    function dispose() {
        releaseEvents();
    }
    function listenForEvents() {
        owner.addEventListener('mousedown', onMouseDown, {
            passive: false
        });
        owner.addEventListener('dblclick', onDoubleClick, {
            passive: false
        });
        owner.addEventListener('touchstart', onTouch, {
            passive: false
        });
        owner.addEventListener('keydown', onKeyDown, {
            passive: false
        });
        // Need to listen on the owner container, so that we are not limited
        // by the size of the scrollable domElement
        $ee3594ab38f6167c$exports.addWheelListener(owner, onMouseWheel, {
            passive: false
        });
        makeDirty();
    }
    function releaseEvents() {
        $ee3594ab38f6167c$exports.removeWheelListener(owner, onMouseWheel);
        owner.removeEventListener('mousedown', onMouseDown);
        owner.removeEventListener('keydown', onKeyDown);
        owner.removeEventListener('dblclick', onDoubleClick);
        owner.removeEventListener('touchstart', onTouch);
        if (frameAnimation) {
            window.cancelAnimationFrame(frameAnimation);
            frameAnimation = 0;
        }
        smoothScroll.cancel();
        releaseDocumentMouse();
        releaseTouches();
        textSelection.release();
        triggerPanEnd();
    }
    function frame() {
        if (isDirty) applyTransform();
    }
    function applyTransform() {
        isDirty = false;
        // TODO: Should I allow to cancel this?
        panController.applyTransform(transform);
        triggerEvent('transform');
        frameAnimation = 0;
    }
    function onKeyDown(e) {
        var x = 0, y = 0, z = 0;
        if (e.keyCode === 38) y = 1; // up
        else if (e.keyCode === 40) y = -1; // down
        else if (e.keyCode === 37) x = 1; // left
        else if (e.keyCode === 39) x = -1; // right
        else if (e.keyCode === 189 || e.keyCode === 109) // DASH or SUBTRACT
        z = 1; // `-` -  zoom out
        else if (e.keyCode === 187 || e.keyCode === 107) // EQUAL SIGN or ADD
        z = -1; // `=` - zoom in (equal sign on US layout is under `+`)
        if (filterKey(e, x, y, z)) // They don't want us to handle the key: https://github.com/anvaka/panzoom/issues/45
        return;
        if (x || y) {
            e.preventDefault();
            e.stopPropagation();
            var clientRect = owner.getBoundingClientRect();
            // movement speed should be the same in both X and Y direction:
            var offset = Math.min(clientRect.width, clientRect.height);
            var moveSpeedRatio = 0.05;
            var dx = offset * moveSpeedRatio * x;
            var dy = offset * moveSpeedRatio * y;
            // TODO: currently we do not animate this. It could be better to have animation
            internalMoveBy(dx, dy);
        }
        if (z) {
            var scaleMultiplier = getScaleMultiplier(z * 100);
            var offset = transformOrigin ? getTransformOriginOffset() : midPoint();
            publicZoomTo(offset.x, offset.y, scaleMultiplier);
        }
    }
    function midPoint() {
        var ownerRect = owner.getBoundingClientRect();
        return {
            x: ownerRect.width / 2,
            y: ownerRect.height / 2
        };
    }
    function onTouch(e) {
        // let them override the touch behavior
        beforeTouch(e);
        clearPendingClickEventTimeout();
        if (e.touches.length === 1) return handleSingleFingerTouch(e, e.touches[0]);
        else if (e.touches.length === 2) {
            // handleTouchMove() will care about pinch zoom.
            pinchZoomLength = getPinchZoomLength(e.touches[0], e.touches[1]);
            multiTouch = true;
            startTouchListenerIfNeeded();
        }
    }
    function beforeTouch(e) {
        // TODO: Need to unify this filtering names. E.g. use `beforeTouch`
        if (options.onTouch && !options.onTouch(e)) // if they return `false` from onTouch, we don't want to stop
        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/12
        return;
        e.stopPropagation();
        e.preventDefault();
    }
    function beforeDoubleClick(e) {
        clearPendingClickEventTimeout();
        // TODO: Need to unify this filtering names. E.g. use `beforeDoubleClick``
        if (options.onDoubleClick && !options.onDoubleClick(e)) // if they return `false` from onTouch, we don't want to stop
        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/46
        return;
        e.preventDefault();
        e.stopPropagation();
    }
    function handleSingleFingerTouch(e) {
        lastTouchStartTime = new Date();
        var touch = e.touches[0];
        var offset = getOffsetXY(touch);
        lastSingleFingerOffset = offset;
        var point = transformToScreen(offset.x, offset.y);
        mouseX = point.x;
        mouseY = point.y;
        clickX = mouseX;
        clickY = mouseY;
        smoothScroll.cancel();
        startTouchListenerIfNeeded();
    }
    function startTouchListenerIfNeeded() {
        if (touchInProgress) // no need to do anything, as we already listen to events;
        return;
        touchInProgress = true;
        document.addEventListener('touchmove', handleTouchMove);
        document.addEventListener('touchend', handleTouchEnd);
        document.addEventListener('touchcancel', handleTouchEnd);
    }
    function handleTouchMove(e) {
        if (e.touches.length === 1) {
            e.stopPropagation();
            var touch = e.touches[0];
            var offset = getOffsetXY(touch);
            var point = transformToScreen(offset.x, offset.y);
            var dx = point.x - mouseX;
            var dy = point.y - mouseY;
            if (dx !== 0 && dy !== 0) triggerPanStart();
            mouseX = point.x;
            mouseY = point.y;
            internalMoveBy(dx, dy);
        } else if (e.touches.length === 2) {
            // it's a zoom, let's find direction
            multiTouch = true;
            var t1 = e.touches[0];
            var t2 = e.touches[1];
            var currentPinchLength = getPinchZoomLength(t1, t2);
            // since the zoom speed is always based on distance from 1, we need to apply
            // pinch speed only on that distance from 1:
            var scaleMultiplier = 1 + (currentPinchLength / pinchZoomLength - 1) * pinchSpeed;
            var firstTouchPoint = getOffsetXY(t1);
            var secondTouchPoint = getOffsetXY(t2);
            mouseX = (firstTouchPoint.x + secondTouchPoint.x) / 2;
            mouseY = (firstTouchPoint.y + secondTouchPoint.y) / 2;
            if (transformOrigin) {
                var offset = getTransformOriginOffset();
                mouseX = offset.x;
                mouseY = offset.y;
            }
            publicZoomTo(mouseX, mouseY, scaleMultiplier);
            pinchZoomLength = currentPinchLength;
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function clearPendingClickEventTimeout() {
        if (pendingClickEventTimeout) {
            clearTimeout(pendingClickEventTimeout);
            pendingClickEventTimeout = 0;
        }
    }
    function handlePotentialClickEvent(e) {
        // we could still be in the double tap mode, let's wait until double tap expires,
        // and then notify:
        if (!options.onClick) return;
        clearPendingClickEventTimeout();
        var dx = mouseX - clickX;
        var dy = mouseY - clickY;
        var l = Math.sqrt(dx * dx + dy * dy);
        if (l > 5) return; // probably they are panning, ignore it
        pendingClickEventTimeout = setTimeout(function() {
            pendingClickEventTimeout = 0;
            options.onClick(e);
        }, $f22fea531ee465de$var$doubleTapSpeedInMS);
    }
    function handleTouchEnd(e) {
        clearPendingClickEventTimeout();
        if (e.touches.length > 0) {
            var offset = getOffsetXY(e.touches[0]);
            var point = transformToScreen(offset.x, offset.y);
            mouseX = point.x;
            mouseY = point.y;
        } else {
            var now = new Date();
            if (now - lastTouchEndTime < $f22fea531ee465de$var$doubleTapSpeedInMS) {
                // They did a double tap here
                if (transformOrigin) {
                    var offset = getTransformOriginOffset();
                    smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
                } else // We want untransformed x/y here.
                smoothZoom(lastSingleFingerOffset.x, lastSingleFingerOffset.y, zoomDoubleClickSpeed);
            } else if (now - lastTouchStartTime < $f22fea531ee465de$var$clickEventTimeInMS) handlePotentialClickEvent(e);
            lastTouchEndTime = now;
            triggerPanEnd();
            releaseTouches();
        }
    }
    function getPinchZoomLength(finger1, finger2) {
        var dx = finger1.clientX - finger2.clientX;
        var dy = finger1.clientY - finger2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }
    function onDoubleClick(e) {
        beforeDoubleClick(e);
        var offset = getOffsetXY(e);
        if (transformOrigin) // TODO: looks like this is duplicated in the file.
        // Need to refactor
        offset = getTransformOriginOffset();
        smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
    }
    function onMouseDown(e) {
        clearPendingClickEventTimeout();
        // if client does not want to handle this event - just ignore the call
        if (beforeMouseDown(e)) return;
        lastMouseDownedEvent = e;
        lastMouseDownTime = new Date();
        if (touchInProgress) {
            // modern browsers will fire mousedown for touch events too
            // we do not want this: touch is handled separately.
            e.stopPropagation();
            return false;
        }
        // for IE, left click == 1
        // for Firefox, left click == 0
        var isLeftButton = e.button === 1 && window.event !== null || e.button === 0;
        if (!isLeftButton) return;
        smoothScroll.cancel();
        var offset = getOffsetXY(e);
        var point = transformToScreen(offset.x, offset.y);
        clickX = mouseX = point.x;
        clickY = mouseY = point.y;
        // We need to listen on document itself, since mouse can go outside of the
        // window, and we will loose it
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        textSelection.capture(e.target || e.srcElement);
        return false;
    }
    function onMouseMove(e) {
        // no need to worry about mouse events when touch is happening
        if (touchInProgress) return;
        triggerPanStart();
        var offset = getOffsetXY(e);
        var point = transformToScreen(offset.x, offset.y);
        var dx = point.x - mouseX;
        var dy = point.y - mouseY;
        mouseX = point.x;
        mouseY = point.y;
        internalMoveBy(dx, dy);
    }
    function onMouseUp() {
        var now = new Date();
        if (now - lastMouseDownTime < $f22fea531ee465de$var$clickEventTimeInMS) handlePotentialClickEvent(lastMouseDownedEvent);
        textSelection.release();
        triggerPanEnd();
        releaseDocumentMouse();
    }
    function releaseDocumentMouse() {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        panstartFired = false;
    }
    function releaseTouches() {
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
        document.removeEventListener('touchcancel', handleTouchEnd);
        panstartFired = false;
        multiTouch = false;
        touchInProgress = false;
    }
    function onMouseWheel(e) {
        // if client does not want to handle this event - just ignore the call
        if (beforeWheel(e)) return;
        smoothScroll.cancel();
        var delta = e.deltaY;
        if (e.deltaMode > 0) delta *= 100;
        var scaleMultiplier = getScaleMultiplier(delta);
        if (scaleMultiplier !== 1) {
            var offset = transformOrigin ? getTransformOriginOffset() : getOffsetXY(e);
            publicZoomTo(offset.x, offset.y, scaleMultiplier);
            e.preventDefault();
        }
    }
    function getOffsetXY(e) {
        var offsetX, offsetY;
        // I tried using e.offsetX, but that gives wrong results for svg, when user clicks on a path.
        var ownerRect = owner.getBoundingClientRect();
        offsetX = e.clientX - ownerRect.left;
        offsetY = e.clientY - ownerRect.top;
        return {
            x: offsetX,
            y: offsetY
        };
    }
    function smoothZoom(clientX, clientY, scaleMultiplier) {
        var fromValue = transform.scale;
        var from = {
            scale: fromValue
        };
        var to = {
            scale: scaleMultiplier * fromValue
        };
        smoothScroll.cancel();
        cancelZoomAnimation();
        zoomToAnimation = $abd4e73c78068168$exports(from, to, {
            step: function(v) {
                zoomAbs(clientX, clientY, v.scale);
            },
            done: triggerZoomEnd
        });
    }
    function smoothZoomAbs(clientX, clientY, toScaleValue) {
        var fromValue = transform.scale;
        var from = {
            scale: fromValue
        };
        var to = {
            scale: toScaleValue
        };
        smoothScroll.cancel();
        cancelZoomAnimation();
        zoomToAnimation = $abd4e73c78068168$exports(from, to, {
            step: function(v) {
                zoomAbs(clientX, clientY, v.scale);
            }
        });
    }
    function getTransformOriginOffset() {
        var ownerRect = owner.getBoundingClientRect();
        return {
            x: ownerRect.width * transformOrigin.x,
            y: ownerRect.height * transformOrigin.y
        };
    }
    function publicZoomTo(clientX, clientY, scaleMultiplier) {
        smoothScroll.cancel();
        cancelZoomAnimation();
        return zoomByRatio(clientX, clientY, scaleMultiplier);
    }
    function cancelZoomAnimation() {
        if (zoomToAnimation) {
            zoomToAnimation.cancel();
            zoomToAnimation = null;
        }
    }
    function getScaleMultiplier(delta) {
        var sign = Math.sign(delta);
        var deltaAdjustedSpeed = Math.min(0.25, Math.abs(speed * delta / 128));
        return 1 - sign * deltaAdjustedSpeed;
    }
    function triggerPanStart() {
        if (!panstartFired) {
            triggerEvent('panstart');
            panstartFired = true;
            smoothScroll.start();
        }
    }
    function triggerPanEnd() {
        if (panstartFired) {
            // we should never run smooth scrolling if it was multiTouch (pinch zoom animation):
            if (!multiTouch) smoothScroll.stop();
            triggerEvent('panend');
        }
    }
    function triggerZoomEnd() {
        triggerEvent('zoomend');
    }
    function triggerEvent(name) {
        api.fire(name, api);
    }
}
function $f22fea531ee465de$var$parseTransformOrigin(options) {
    if (!options) return;
    if (typeof options === 'object') {
        if (!$f22fea531ee465de$var$isNumber(options.x) || !$f22fea531ee465de$var$isNumber(options.y)) $f22fea531ee465de$var$failTransformOrigin(options);
        return options;
    }
    $f22fea531ee465de$var$failTransformOrigin();
}
function $f22fea531ee465de$var$failTransformOrigin(options) {
    console.error(options);
    throw new Error([
        'Cannot parse transform origin.',
        'Some good examples:',
        '  "center center" can be achieved with {x: 0.5, y: 0.5}',
        '  "top center" can be achieved with {x: 0.5, y: 0}',
        '  "bottom right" can be achieved with {x: 1, y: 1}'
    ].join('\n'));
}
function $f22fea531ee465de$var$noop() {}
function $f22fea531ee465de$var$validateBounds(bounds) {
    var boundsType = typeof bounds;
    if (boundsType === 'undefined' || boundsType === 'boolean') return; // this is okay
    // otherwise need to be more thorough:
    var validBounds = $f22fea531ee465de$var$isNumber(bounds.left) && $f22fea531ee465de$var$isNumber(bounds.top) && $f22fea531ee465de$var$isNumber(bounds.bottom) && $f22fea531ee465de$var$isNumber(bounds.right);
    if (!validBounds) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
}
function $f22fea531ee465de$var$isNumber(x) {
    return Number.isFinite(x);
}
// IE 11 does not support isNaN:
function $f22fea531ee465de$var$isNaN(value) {
    if (Number.isNaN) return Number.isNaN(value);
    return value !== value;
}
function $f22fea531ee465de$var$rigidScroll() {
    return {
        start: $f22fea531ee465de$var$noop,
        stop: $f22fea531ee465de$var$noop,
        cancel: $f22fea531ee465de$var$noop
    };
}
function $f22fea531ee465de$var$autoRun() {
    if (typeof document === 'undefined') return;
    var scripts = document.getElementsByTagName('script');
    if (!scripts) return;
    var panzoomScript;
    for(var i = 0; i < scripts.length; ++i){
        var x = scripts[i];
        if (x.src && x.src.match(/\bpanzoom(\.min)?\.js/)) {
            panzoomScript = x;
            break;
        }
    }
    if (!panzoomScript) return;
    var query = panzoomScript.getAttribute('query');
    if (!query) return;
    var globalName = panzoomScript.getAttribute('name') || 'pz';
    var started = Date.now();
    tryAttach();
    function tryAttach() {
        var el = document.querySelector(query);
        if (!el) {
            var now = Date.now();
            var elapsed = now - started;
            if (elapsed < 2000) {
                // Let's wait a bit
                setTimeout(tryAttach, 100);
                return;
            }
            // If we don't attach within 2 seconds to the target element, consider it a failure
            console.error('Cannot find the panzoom element', globalName);
            return;
        }
        var options = collectOptions(panzoomScript);
        console.log(options);
        window[globalName] = $f22fea531ee465de$var$createPanZoom(el, options);
    }
    function collectOptions(script) {
        var attrs = script.attributes;
        var options = {};
        for(var j = 0; j < attrs.length; ++j){
            var attr = attrs[j];
            var nameValue = getPanzoomAttributeNameValue(attr);
            if (nameValue) options[nameValue.name] = nameValue.value;
        }
        return options;
    }
    function getPanzoomAttributeNameValue(attr) {
        if (!attr.name) return;
        var isPanZoomAttribute = attr.name[0] === 'p' && attr.name[1] === 'z' && attr.name[2] === '-';
        if (!isPanZoomAttribute) return;
        var name = attr.name.substr(3);
        var value = JSON.parse(attr.value);
        return {
            name: name,
            value: value
        };
    }
}
$f22fea531ee465de$var$autoRun();


const $9d936a2aecb96285$export$c42c4b43e6ce031e = [
    {
        title: "01. La garderie d'art",
        audio: "01-la-garderie-d-art.mp3",
        clip: "01-hauts-parleurs_02.webm",
        pos: [
            863,
            270
        ]
    },
    {
        title: "02. C\u0327a tourne",
        audio: "02-ca-tourne.mp3",
        clip: "02-ca-tourne8fps_02.webm",
        pos: [
            863,
            321
        ]
    },
    {
        title: "03. Marins Schtroumpfs",
        audio: "03-marins-schtroumpfs.mp3",
        clip: "03-cymbale_02.webm",
        pos: [
            863,
            372
        ]
    },
    {
        title: "04. Market Tango",
        audio: "04-market-tango.mp3",
        clip: "04-plante_02.webm",
        pos: [
            863,
            423
        ]
    },
    {
        title: "05. St-Me\u0301rite\u0301 les che\u0302nes (pt.1)",
        audio: "05-st-merite-les-chenes-pt1.mp3",
        clip: "05-helices_02.webm",
        pos: [
            863,
            474
        ]
    },
    {
        title: "06. St-Me\u0301rite\u0301 les che\u0302nes (pt.2) (Hommage aux cinq pachydermes)",
        audio: "06-st-merite-les-chenes-pt2.mp3",
        clip: "06-cadre-photo_02.webm",
        pos: [
            863,
            524
        ]
    },
    {
        title: "07. Patadorf",
        audio: "07-patadorf.mp3",
        clip: "07-reparer-la-machine_02.webm",
        pos: [
            863,
            575
        ]
    },
    {
        title: "08. Buddah.com",
        audio: "08-buddah-com.mp3",
        clip: "08-chercher-vinyle_02.webm",
        pos: [
            863,
            626
        ]
    },
    {
        title: "09. Alice & Marius",
        audio: "09-alice-marius.mp3",
        clip: "09-lecture_02.webm",
        pos: [
            863,
            678
        ]
    },
    {
        title: "10. Elephant_sadness",
        audio: "10-elephant-sadness.mp3",
        clip: "10-fleur-a-vent_02.webm",
        pos: [
            863,
            728
        ]
    },
    {
        title: "11. The\u0301rapie de groupe",
        audio: "11-therapie-de-groupe.mp3",
        clip: "11-tourner-sur-tabouret_02.webm",
        pos: [
            1198,
            270
        ]
    },
    {
        title: "12. Le jambon c'est si bon",
        audio: "12-le-jambon-c-est-si-bon.mp3",
        clip: "12-ou-va-le-cable_02.webm",
        pos: [
            1198,
            321
        ]
    },
    {
        title: "13. Attack of the cows",
        audio: "13-attack-of-the-cows.mp3",
        clip: "13-tous-les-boutons_02.webm",
        pos: [
            1198,
            372
        ]
    },
    {
        title: "14. A\u0300 nos beurgueurs",
        audio: "14-a-nos-beurgueurs.mp3",
        clip: "14-climatisation_02.webm",
        pos: [
            1198,
            423
        ]
    },
    {
        title: "15. Gustavo Del_Totche",
        audio: "15-gustavo-del-totche.mp3",
        clip: "15-lampe_02.webm",
        pos: [
            1198,
            474
        ],
        dark: true
    },
    {
        title: "16. Coeur liquide",
        audio: "16-coeur-liquide.mp3",
        clip: "16-bricolage_02.webm",
        pos: [
            1198,
            525
        ]
    },
    {
        title: "17. L'abonnement a\u0300 la piscine",
        audio: "17-l-abonnement-a-la-piscine.mp3",
        clip: "17-trier-les-vis_02.webm",
        pos: [
            1198,
            575
        ]
    },
    {
        title: "18. Fum thon plastickk",
        audio: "18-fum-thon-plastickk.mp3",
        clip: "18-cafetiere_02.webm",
        pos: [
            1198,
            626
        ]
    },
    {
        title: "19. Rome\u0301o & Yvette",
        audio: "19-romeo-yvette.mp3",
        clip: "19-machines-musique_02.webm",
        pos: [
            1198,
            678
        ]
    },
    {
        title: "20. Re\u0302verie pour tortellini n\xb01",
        audio: "20-reverie-pour-tortellini-n1.mp3",
        clip: "20-couche-par-terre_02.webm",
        pos: [
            1198,
            728
        ]
    }
];


var $ed80fa8833e2b532$exports = {};
var $3384256242a1b577$exports = {};
var $dcb2a7eb44d37cba$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dcb2a7eb44d37cba$exports = $dcb2a7eb44d37cba$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $dcb2a7eb44d37cba$exports($3384256242a1b577$var$deburredLetters);
$3384256242a1b577$exports = $3384256242a1b577$var$deburrLetter;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};
var $3ba72ebe7e4419b5$exports = {};
var $180b2bc3c0deaf6c$exports = {};
var $f84e62f9db5b9ccd$exports = {};
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$f84e62f9db5b9ccd$exports = $f84e62f9db5b9ccd$var$freeGlobal;


/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $f84e62f9db5b9ccd$exports || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
$180b2bc3c0deaf6c$exports = $180b2bc3c0deaf6c$var$root;


/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $180b2bc3c0deaf6c$exports.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;


var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};

var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + '';
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = '\\u0300-\\u036f', $ed80fa8833e2b532$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ed80fa8833e2b532$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = '[' + $ed80fa8833e2b532$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $f5d9385a9cc7e413$exports(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $3384256242a1b577$exports).replace($ed80fa8833e2b532$var$reComboMark, '');
}
$ed80fa8833e2b532$exports = $ed80fa8833e2b532$var$deburr;


var $d9f195cb3938646c$exports = {};
var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


var $6d38303b9c8735ba$exports = {};

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $180b2bc3c0deaf6c$exports.Date.now();
};
$6d38303b9c8735ba$exports = $6d38303b9c8735ba$var$now;


var $dc614d828223dea6$exports = {};
var $0542da1d887b1c4d$exports = {};
var $ef99cce288c7323e$exports = {};
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$ef99cce288c7323e$exports = $ef99cce288c7323e$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $ef99cce288c7323e$exports(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
$0542da1d887b1c4d$exports = $0542da1d887b1c4d$var$baseTrim;




/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6b5a5095e0934938$exports(value)) return $dc614d828223dea6$var$NAN;
    if ($f9ff2e983beb6b86$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f9ff2e983beb6b86$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $0542da1d887b1c4d$exports(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
$dc614d828223dea6$exports = $dc614d828223dea6$var$toNumber;


/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $dc614d828223dea6$exports(wait) || 0;
    if ($f9ff2e983beb6b86$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($dc614d828223dea6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6d38303b9c8735ba$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6d38303b9c8735ba$exports());
    }
    function debounced() {
        var time = $6d38303b9c8735ba$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d9f195cb3938646c$exports = $d9f195cb3938646c$var$debounce;


const $ad2bcec7a0192558$var$jukebox = document.getElementById("jukebox");
const $ad2bcec7a0192558$var$pascal = document.getElementById("pascal");
const $ad2bcec7a0192558$var$josue = document.getElementById("josue");
const $ad2bcec7a0192558$var$audioPlayer = document.getElementById("audio-player");
const $ad2bcec7a0192558$var$volumeSlider = document.querySelector("#volume-control input[type='range']");
const $ad2bcec7a0192558$var$volumeIndicator = document.querySelector("#volume-control img");
const $ad2bcec7a0192558$var$muteButton = document.querySelector("#volume-control button");
// We have two player instances on the page to support a smooth transition between the two videos
// Instead of video1 and video2, let's call them Pascal and Josué :D
let $ad2bcec7a0192558$var$currentPlayer = "pascal";
// Track the currently playing track index
let $ad2bcec7a0192558$var$currentTrackIndex = -1;
// Store last non-zero volume to restore when unmuting
let $ad2bcec7a0192558$var$previousVolume = 1;
// Store the PanZoom instance to be able to dispose and recreate it
let $ad2bcec7a0192558$var$panZoomInstance = null;
const $ad2bcec7a0192558$var$block = (e)=>{
    if ($ad2bcec7a0192558$var$jukebox.contains(e.target)) e.preventDefault();
};
document.addEventListener("gesturestart", $ad2bcec7a0192558$var$block);
document.addEventListener("gesturechange", $ad2bcec7a0192558$var$block);
function $ad2bcec7a0192558$var$switchVideoPlayer(track) {
    const activePlayer = $ad2bcec7a0192558$var$currentPlayer === "pascal" ? $ad2bcec7a0192558$var$pascal : $ad2bcec7a0192558$var$josue;
    const nextPlayer = $ad2bcec7a0192558$var$currentPlayer === "pascal" ? $ad2bcec7a0192558$var$josue : $ad2bcec7a0192558$var$pascal;
    // Make sure the next player starts fully hidden and the current stays visible
    nextPlayer.classList.add("opacity-0");
    nextPlayer.classList.remove("opacity-100");
    activePlayer.classList.remove("opacity-0");
    activePlayer.classList.add("opacity-100");
    // Set the new source on the inactive player
    nextPlayer.src = `/static/${track.clip}`;
    // When the inactive player is ready, start the cross-fade
    const onCanPlay = ()=>{
        // Start playing the new video (ignore promise for older browsers)
        nextPlayer.play();
        // Fade out current player and fade in new player
        activePlayer.classList.add("opacity-0");
        activePlayer.classList.remove("opacity-100");
        nextPlayer.classList.remove("opacity-0");
        nextPlayer.classList.add("opacity-100");
        // Switch the current player reference
        $ad2bcec7a0192558$var$currentPlayer = $ad2bcec7a0192558$var$currentPlayer === "pascal" ? "josue" : "pascal";
        // After transition completes, pause the now-hidden player
        setTimeout(()=>{
            // Update theme when the new video starts playing
            document.documentElement.classList.toggle("dark", !!track.dark);
            document.documentElement.classList.toggle("light", !track.dark);
            activePlayer.pause();
            // Update MediaSession metadata if theme changed (for artwork)
            if ($ad2bcec7a0192558$var$currentTrackIndex >= 0) $ad2bcec7a0192558$var$updateMediaSessionMetadata((0, $9d936a2aecb96285$export$c42c4b43e6ce031e)[$ad2bcec7a0192558$var$currentTrackIndex]);
        }, 100);
    };
    nextPlayer.addEventListener("canplay", onCanPlay, {
        once: true
    });
    // Start loading the new video
    nextPlayer.load();
}
function $ad2bcec7a0192558$var$playTrack(trackIndex) {
    if (trackIndex < 0 || trackIndex >= (0, $9d936a2aecb96285$export$c42c4b43e6ce031e).length) return;
    const track = (0, $9d936a2aecb96285$export$c42c4b43e6ce031e)[trackIndex];
    $ad2bcec7a0192558$var$currentTrackIndex = trackIndex;
    // Remove active class from all tracks
    document.querySelectorAll(".track.active").forEach((t)=>{
        t.classList.remove("active");
    });
    // Add active class to current track
    const trackElements = document.querySelectorAll(".track");
    if (trackElements[trackIndex]) trackElements[trackIndex].classList.add("active");
    // Update URL hash using the audio filename without extension
    const hashName = track.audio.replace(".mp3", "");
    history.replaceState(null, "", `#${hashName}`);
    // Update window title
    document.title = `${track.title} | Glaucal Cristal Session | Jukebox \u{1F3B6}`;
    // Switch video and audio
    $ad2bcec7a0192558$var$switchVideoPlayer(track);
    $ad2bcec7a0192558$var$audioPlayer.setAttribute("src", `/static/${track.audio}`);
    $ad2bcec7a0192558$var$audioPlayer.play();
    // Update MediaSession metadata
    $ad2bcec7a0192558$var$updateMediaSessionMetadata(track);
}
function $ad2bcec7a0192558$var$playNextTrack() {
    if ($ad2bcec7a0192558$var$currentTrackIndex < (0, $9d936a2aecb96285$export$c42c4b43e6ce031e).length - 1) $ad2bcec7a0192558$var$playTrack($ad2bcec7a0192558$var$currentTrackIndex + 1);
    else $ad2bcec7a0192558$var$playTrack(0);
}
function $ad2bcec7a0192558$var$playPreviousTrack() {
    if ($ad2bcec7a0192558$var$currentTrackIndex > 0) $ad2bcec7a0192558$var$playTrack($ad2bcec7a0192558$var$currentTrackIndex - 1);
    else $ad2bcec7a0192558$var$playTrack((0, $9d936a2aecb96285$export$c42c4b43e6ce031e).length - 1);
}
// Helper to update the volume icon according to current state
function $ad2bcec7a0192558$var$updateVolumeIndicator() {
    const volume = $ad2bcec7a0192558$var$audioPlayer.muted ? 0 : $ad2bcec7a0192558$var$audioPlayer.volume;
    let level;
    if (volume === 0) level = "mute";
    else if (volume <= 0.33) level = "low";
    else if (volume <= 0.66) level = "medium";
    else level = "high";
    $ad2bcec7a0192558$var$volumeIndicator.src = `/static/volume-${level}.png`;
}
// Initialize MediaSession API for better native media controls
function $ad2bcec7a0192558$var$initializeMediaSession() {
    if (!("mediaSession" in navigator)) return; // MediaSession not supported
    // Register action handlers
    navigator.mediaSession.setActionHandler("play", ()=>{
        $ad2bcec7a0192558$var$audioPlayer.play().catch((error)=>console.error("MediaSession play error:", error));
    });
    navigator.mediaSession.setActionHandler("pause", ()=>{
        $ad2bcec7a0192558$var$audioPlayer.pause();
    });
    navigator.mediaSession.setActionHandler("nexttrack", ()=>{
        $ad2bcec7a0192558$var$playNextTrack();
    });
    navigator.mediaSession.setActionHandler("previoustrack", ()=>{
        $ad2bcec7a0192558$var$playPreviousTrack();
    });
}
// Update MediaSession metadata for the current track
function $ad2bcec7a0192558$var$updateMediaSessionMetadata(track) {
    if (!("mediaSession" in navigator)) return; // MediaSession not supported
    const isDark = document.documentElement.classList.contains("dark");
    const artwork = isDark ? "/static/logo-dark.png" : "/static/logo-light.png";
    navigator.mediaSession.metadata = new MediaMetadata({
        title: track.title,
        artist: "Glaucal Cristal Session",
        album: "Jukebox \uD83C\uDFB6",
        artwork: [
            {
                src: artwork,
                sizes: "512x512",
                type: "image/png"
            },
            {
                src: artwork,
                sizes: "256x256",
                type: "image/png"
            },
            {
                src: artwork,
                sizes: "192x192",
                type: "image/png"
            },
            {
                src: artwork,
                sizes: "128x128",
                type: "image/png"
            },
            {
                src: artwork,
                sizes: "96x96",
                type: "image/png"
            }
        ]
    });
}
function $ad2bcec7a0192558$var$initializePanZoom() {
    if ($ad2bcec7a0192558$var$panZoomInstance) $ad2bcec7a0192558$var$panZoomInstance.dispose();
    const dialog = document.getElementById("about-dialog");
    /** @see https://github.com/anvaka/panzoom */ $ad2bcec7a0192558$var$panZoomInstance = (0, (/*@__PURE__*/$parcel$interopDefault($f22fea531ee465de$exports)))($ad2bcec7a0192558$var$jukebox, {
        maxZoom: 2,
        minZoom: 0.2,
        autocenter: true,
        bounds: true,
        onTouch: (event)=>{
            // Prevent panning when dialog is open
            if (!(event.target instanceof HTMLElement)) return;
            if (dialog?.open || !event.target.closest(".no-pan")) return false;
        },
        beforeMouseDown: (event)=>{
            // Prevent panning when dialog is open
            if (dialog?.open) return true;
            if (!(event.target instanceof HTMLElement)) return;
            if (event.target.closest(".no-pan")) return true;
        }
    });
}
function $ad2bcec7a0192558$var$renderTracks() {
    const [w, h] = [
        320,
        32
    ]; // Clickable box size
    const offsetY = 10;
    const offsetX = 5;
    for (const [index, track] of (0, $9d936a2aecb96285$export$c42c4b43e6ce031e).entries()){
        const [x, y] = track.pos;
        const div = document.createElement("div");
        div.className = "track no-pan";
        div.style.top = `${y - offsetY}px`;
        div.style.left = `${x - offsetX}px`;
        div.style.width = `${w + offsetX}px`;
        div.style.height = `${h + offsetY}px`;
        div.innerHTML = `<div class="track__content">
      <div class="track__title">
        <span>${(0, (/*@__PURE__*/$parcel$interopDefault($ed80fa8833e2b532$exports)))(track.title)}</span>
        <span>${(0, (/*@__PURE__*/$parcel$interopDefault($ed80fa8833e2b532$exports)))(track.title)}</span>
      </div>
    </div>`;
        div.title = track.title;
        div.addEventListener("click", (ev)=>{
            $ad2bcec7a0192558$var$playTrack(index);
        });
        $ad2bcec7a0192558$var$jukebox?.appendChild(div);
    }
}
function $ad2bcec7a0192558$var$initializeControls() {
    $ad2bcec7a0192558$var$volumeSlider.addEventListener("input", ()=>{
        const value = parseFloat($ad2bcec7a0192558$var$volumeSlider.value);
        $ad2bcec7a0192558$var$audioPlayer.volume = value;
        // Automatically toggle muted state depending on slider value
        if (value === 0) $ad2bcec7a0192558$var$audioPlayer.muted = true;
        else {
            $ad2bcec7a0192558$var$audioPlayer.muted = false;
            $ad2bcec7a0192558$var$previousVolume = value;
        }
        $ad2bcec7a0192558$var$updateVolumeIndicator();
    });
    // Toggle mute / unmute when clicking on the icon or button
    $ad2bcec7a0192558$var$muteButton.addEventListener("click", ()=>{
        if ($ad2bcec7a0192558$var$audioPlayer.muted || $ad2bcec7a0192558$var$audioPlayer.volume === 0) {
            // Unmute and restore previous volume (or default to full volume)
            const restored = $ad2bcec7a0192558$var$previousVolume || 1;
            $ad2bcec7a0192558$var$audioPlayer.muted = false;
            $ad2bcec7a0192558$var$audioPlayer.volume = restored;
            $ad2bcec7a0192558$var$volumeSlider.value = restored.toString();
        } else {
            // Mute – remember current volume so we can restore it later
            $ad2bcec7a0192558$var$previousVolume = $ad2bcec7a0192558$var$audioPlayer.volume || 1;
            $ad2bcec7a0192558$var$audioPlayer.muted = true;
            $ad2bcec7a0192558$var$volumeSlider.value = "0";
        }
        $ad2bcec7a0192558$var$updateVolumeIndicator();
    });
    // Initial icon state
    $ad2bcec7a0192558$var$updateVolumeIndicator();
    // Add event listener for when a track ends
    $ad2bcec7a0192558$var$audioPlayer.addEventListener("ended", $ad2bcec7a0192558$var$playNextTrack);
}
// Debounced resize handler - only reinitialize PanZoom
const $ad2bcec7a0192558$var$handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(()=>{
    $ad2bcec7a0192558$var$initializePanZoom();
}, 300);
document.addEventListener("DOMContentLoaded", ()=>{
    // Trigger entrance animations after a delay to let panzoom initialize
    setTimeout(()=>{
        const logoElement = document.getElementById("logo");
        const mainElement = document.querySelector("main");
        if (logoElement) logoElement.classList.add("animate-in");
        if (mainElement) mainElement.classList.add("animate-in");
    }, 100); // 0.5 second delay
    $ad2bcec7a0192558$var$renderTracks();
    $ad2bcec7a0192558$var$initializeControls();
    $ad2bcec7a0192558$var$initializePanZoom();
    $ad2bcec7a0192558$var$initializeMediaSession();
    // Setup the dialog element
    const dialog = document.getElementById("about-dialog");
    const logo = document.getElementById("logo");
    const closeButton = dialog?.querySelector("button");
    if (dialog && logo) {
        // Add click handler to logo
        logo.addEventListener("click", ()=>{
            dialog.showModal();
        });
        // Close modal when clicking outside (on backdrop)
        dialog.addEventListener("click", (e)=>{
            const rect = dialog.getBoundingClientRect();
            const isInDialog = rect.top <= e.clientY && e.clientY <= rect.bottom && rect.left <= e.clientX && e.clientX <= rect.right;
            if (!isInDialog) dialog.close();
        });
        // Close modal when clicking close button
        closeButton?.addEventListener("click", ()=>{
            dialog.close();
        });
    // Close dialog on Escape key (built-in to dialog element)
    }
    // Add keyboard shortcuts
    document.addEventListener("keydown", (e)=>{
        // Don't handle shortcuts when dialog is open
        if (dialog?.open) return;
        // F for fullscreen
        if (e.key === "f" || e.key === "F") {
            if (!document.fullscreenElement) document.documentElement.requestFullscreen();
            else document.exitFullscreen();
        }
        // Left/Right for track navigation
        if (e.key === "ArrowLeft") $ad2bcec7a0192558$var$playPreviousTrack();
        else if (e.key === "ArrowRight") $ad2bcec7a0192558$var$playNextTrack();
        // Up/Down for volume
        if (e.key === "ArrowUp") {
            e.preventDefault();
            const newVolume = Math.min(1, $ad2bcec7a0192558$var$audioPlayer.volume + 0.1);
            $ad2bcec7a0192558$var$audioPlayer.volume = newVolume;
            $ad2bcec7a0192558$var$volumeSlider.value = newVolume.toString();
            if ($ad2bcec7a0192558$var$audioPlayer.muted && newVolume > 0) $ad2bcec7a0192558$var$audioPlayer.muted = false;
            $ad2bcec7a0192558$var$updateVolumeIndicator();
        } else if (e.key === "ArrowDown") {
            e.preventDefault();
            const newVolume = Math.max(0, $ad2bcec7a0192558$var$audioPlayer.volume - 0.1);
            $ad2bcec7a0192558$var$audioPlayer.volume = newVolume;
            $ad2bcec7a0192558$var$volumeSlider.value = newVolume.toString();
            if (newVolume === 0) $ad2bcec7a0192558$var$audioPlayer.muted = true;
            $ad2bcec7a0192558$var$updateVolumeIndicator();
        }
    });
    // Check URL hash on load
    const hash = window.location.hash.slice(1); // Remove the #
    if (hash) {
        // Find track by audio filename
        const trackIndex = (0, $9d936a2aecb96285$export$c42c4b43e6ce031e).findIndex((track)=>track.audio.replace(".mp3", "") === hash);
        if (trackIndex !== -1) $ad2bcec7a0192558$var$playTrack(trackIndex);
    }
    // Handle resize and orientation change
    window.addEventListener("resize", ()=>$ad2bcec7a0192558$var$handleResize());
    window.addEventListener("orientationchange", ()=>$ad2bcec7a0192558$var$handleResize());
    document.addEventListener("fullscreenchange", ()=>$ad2bcec7a0192558$var$handleResize());
});


//# sourceMappingURL=glaucal.fun.4a2e3cda.js.map
